import React, { useState } from 'react';
import { useInputPrice } from '@/hooks/form/useInputPrice';
import styles from '../Expense.module.scss';
import clsx from 'clsx';

export default function ExpenseBillForm({
  canCreateExpenseBill,
  canManageExpense,
  items,
  saving,
  onSubmit,
  onManage,
}) {
  const [expense, setExpense] = useState('');
  const {
    value: price,
    displayValue: displayPrice,
    onChange: setPrice,
  } = useInputPrice('');
  const [note, setNote] = useState('');

  if (!canCreateExpenseBill) return null;

  return (
    <form
      className={styles.form}
      onSubmit={async (e) => {
        e.preventDefault();
        if (
          await onSubmit({
            expense: Number(expense),
            price: Number(price || 0),
            note,
          })
        ) {
          setPrice('');
          setNote('');
        }
      }}
    >
      <div className={styles.inputWrapper}>
        <div className={styles.selectLabelWrapper}>
          <label htmlFor="expense-reason" className={styles.label}>
            Khoản chi
          </label>

          {canManageExpense && (
            <i
              className={clsx(styles.icon, 'fa fa-circle-plus')}
              onClick={onManage}
            />
          )}
        </div>

        <select
          id="expense-reason"
          className={styles.select}
          required
          value={
            items.some((item) => String(item.id) === expense)
              ? expense
              : ''
          }
          onChange={(e) => setExpense(e.target.value)}
        >
          <option value="">Chọn khoản chi</option>
          {items.map((item) => (
            <option key={item.id} value={item.id}>
              {item.name}
            </option>
          ))}
        </select>
      </div>

      <div className={styles.inputWrapper}>
        <label htmlFor="expense-price" className={styles.label}>
          Số tiền
        </label>
        <input
          id="expense-price"
          className={styles.input}
          required
          value={displayPrice}
          onChange={setPrice}
        />
      </div>
      <div className={styles.inputWrapper}>
        <label htmlFor="expense-note" className={styles.label}>
          Ghi chú
        </label>
        <input
          id="expense-note"
          className={styles.input}
          maxLength={255}
          value={note}
          onChange={(e) => setNote(e.target.value)}
        />
      </div>
      <button className={styles.btn} disabled={saving}>
        Thêm
      </button>
    </form>
  );
}
